var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpsmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f8d151db-c9eb-47d5-9bab-50a53a3c9450",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 247.3509 365.8399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a3e43e7b-486b-4089-aba4-badd9f4914d6",
    x1: 248.1016,
    y1: 162.892,
    x2: 355.2861,
    y2: 162.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3787,
    stopColor: "#57d9a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36b37e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e533210c-806d-4154-8f24-42ca06e0f85b",
    x1: 142.087,
    y1: 274.3434,
    x2: 248.1016,
    y2: 274.3434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffab00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2661f1d-f73a-4726-9297-578db64237b3",
    x1: 216.8183,
    y1: 289.9851,
    x2: 355.2202,
    y2: 289.9851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab915a0d-9681-4672-9bc0-b41d43435cd8",
    x1: 107.9352,
    y1: 147.0859,
    x2: 225.1154,
    y2: 147.0859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2647,
    stopColor: "#b3f5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e5",
    stopOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M251.3225,149.5533a3.2021,3.2021,0,0,0,2.713-1.5066A13.72,13.72,0,1,1,253.9,162.34a2.6458,2.6458,0,0,0-2.2674-1.2844h-.0846a3.4458,3.4458,0,0,0-3.446,3.4457v43.1217l46.15,0a3.2207,3.2207,0,0,1,3.2206,3.2207v.0527a3.1087,3.1087,0,0,1-1.4688,2.6372,13.72,13.72,0,1,0,14.2559-.1125,2.6458,2.6458,0,0,1-1.2844-2.2675v-.0849a3.4459,3.4459,0,0,1,3.4458-3.4457h42.8c.0168-.8659.0659-1.723.0659-2.5934,0-65.2541-47.74-118.1527-106.6314-118.1527-.1853,0-.3678.0145-.5531.0156v59.4394A3.221,3.221,0,0,0,251.3225,149.5533Z",
    transform: "translate(-107.9352 -70.1093)",
    style: {
      fill: "url(#a3e43e7b-486b-4089-aba4-badd9f4914d6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1016,280.82v-1.2943a3.4459,3.4459,0,0,0-3.446-3.4457h-.0849a2.6462,2.6462,0,0,0-2.2674,1.2843,13.7205,13.7205,0,1,1-.1124-14.256,3.1077,3.1077,0,0,0,2.6372,1.4691h.0523a3.221,3.221,0,0,0,3.2212-3.2209V207.6233l-50.7056,0a3.4458,3.4458,0,0,1-3.4457-3.4457v-.0849a2.646,2.646,0,0,1,1.2843-2.2676,13.72,13.72,0,1,0-14.2937-.1357,3.212,3.212,0,0,1-1.714,5.9339h-37.14c.6606,33.8427,14.1257,64.1892,35.2867,85.277,19.3483,19.2813,30.14,44.8342,30.14,71.399v8.0478h40.5878V280.82Z",
    transform: "translate(-107.9352 -70.1093)",
    style: {
      fill: "url(#e533210c-806d-4154-8f24-42ca06e0f85b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1715,207.6235h-8.751a3.4459,3.4459,0,0,0-3.4458,3.4457v.0849a2.6458,2.6458,0,0,0,1.2844,2.2675,13.7207,13.7207,0,1,1-14.2559.1125,3.1087,3.1087,0,0,0,1.4688-2.6372v-.0527a3.2207,3.2207,0,0,0-3.2206-3.2207l-46.15,0v53.7336a3.221,3.221,0,0,1-3.2212,3.2209h-.0523a3.1077,3.1077,0,0,1-2.6372-1.4691,13.72,13.72,0,1,0,.1124,14.256,2.6462,2.6462,0,0,1,2.2674-1.2843h.0849a3.4459,3.4459,0,0,1,3.446,3.4457V372.347H283.079c0-28.8666,12.2653-56.5015,34.0524-76.7461,22.7666-21.1543,37.3991-52.6625,38.0888-87.9774Z",
    transform: "translate(-107.9352 -70.1093)",
    style: {
      fill: "url(#a2661f1d-f73a-4726-9297-578db64237b3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.7967,368.9884l86.76,3.3585,4.4779,10.6352-5.5975,4.4779,5.5975,7.8364-5.5975,8.3962-.56,17.352s-1.6792,11.1949-44.22,14.5534-40.8613-18.4715-40.8613-18.4715V402.4689l-5.5974-11.65,5.5974-6.1572-5.5974-6.717Z",
    transform: "translate(-107.9352 -70.1093)",
    style: {
      fill: "#42526e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2509,204.2951a3.2023,3.2023,0,0,0-2.5012-1.8371,13.72,13.72,0,1,1,13.0466-5.8406,2.6458,2.6458,0,0,0-.2211,2.5966l.0355.0771a3.4458,3.4458,0,0,0,4.5691,1.6937l46.0809-21.1567-17.9925-39.1887a3.4458,3.4458,0,0,1,1.694-4.5693l.0768-.0353a2.6458,2.6458,0,0,1,2.5965.2212,13.7208,13.7208,0,1,0-5.84-13.0466,3.212,3.212,0,0,1-6.108.918L166.886,70.1093c-53.1483,24.767-74.2515,92.5076-47.11,151.6231.3631.7907.7631,1.55,1.14,2.33l33.7525-15.4966A3.2208,3.2208,0,0,0,156.2509,204.2951Z",
    transform: "translate(-107.9352 -70.1093)",
    style: {
      fill: "url(#ab915a0d-9681-4672-9bc0-b41d43435cd8)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpsmart);
export default __webpack_public_path__ + "static/media/erpsmart.628fb0b723e4cba640237cfc8a3ed99b.svg";
export { ForwardRef as ReactComponent };